(function($){

	$(document).ready(function(){

		$(document).on('click','.btn-generate-pdf',function(e){
			e.preventDefault();
			var postid = $(this).data('postid');

			if(postid) {
				redirect_url = window.location.protocol + '//' + window.location.hostname + '?generate_pdf=' + postid;
				window.location.href = redirect_url;
			}
		});

	});
	
})(jQuery);